import type ExtensibilityState from './schema/ExtensibilityState';
import getExtensibilityState from './getExtensibilityState';

export default function getAllActiveControlIds(hostItemIndex: string): string[] {
    const state = getExtensibilityState();
    const taskPaneIds = getTaskPaneControlIds(hostItemIndex, state);
    const uilessIds = getUilessControlIds(hostItemIndex, state);
    const contextualIds = getContextualControlIds(hostItemIndex, state);
    return [...taskPaneIds, ...uilessIds, ...contextualIds];
}

function getTaskPaneControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    let controlIdsForHostItemIndex = [];
    let taskPanes = state.taskPanes;
    for (let taskPaneAddins of taskPanes.values()) {
        for (let taskPaneInstance of taskPaneAddins.values()) {
            if (taskPaneInstance.hostItemIndex === hostItemIndex) {
                controlIdsForHostItemIndex.push(taskPaneInstance.controlId);
            }
        }
    }
    return controlIdsForHostItemIndex;
}

function getUilessControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    let controlIdsForHostItemIndex = [];
    const uilessAddins = state.runningUILessExtendedAddinCommands;
    uilessAddins.forEach((addinCommandMap, addinInstanceString) => {
        const addinInstance = JSON.parse(addinInstanceString);
        if (addinInstance.hostItemIndex === hostItemIndex) {
            for (let controlId of addinCommandMap.keys()) {
                controlIdsForHostItemIndex.push(controlId);
            }
        }
    });
    return controlIdsForHostItemIndex;
}

function getContextualControlIds(hostItemIndex: string, state: ExtensibilityState): string[] {
    const contextualAddins = state.runningContextualAddinCommand;
    if (contextualAddins && contextualAddins.hostItemIndex === hostItemIndex) {
        return [state.runningContextualAddinCommand.controlId];
    }
    return [];
}
